<div class="card">
  <div class="list-group list-group-flush h-100">
    <a
      *ngFor="let item of items"
      [href]="item.href"
      [class]="'list-group-item flex-fill d-flex align-items-center ' + item.linkTracking.cssClass"
    >
      <div>
        <strong>{{ item.title }}</strong>
        <p>{{ item.text }}</p>
      </div>
    </a>
  </div>
</div>
